import React from "react"
import PropTypes from "prop-types"
import { Droppable } from "@hello-pangea/dnd"

// Components
import PlannerItem from "../PipelineItem/PipelineItem"

// Style
import {
  ColumnContainer,
  ColumnHeaderContainer,
  ColumnHeader,
  ColumnBody,
  TriangleStyleOne,
  TriangleStyleTwo,
  ChipsItem,
} from "./PipelineColumn.style"

const PlannerColumn = ({ index, name, items, widthColumn }) => {
  return (
    <Droppable droppableId={`${index}`}>
      {provided => {
        return (
          <ColumnContainer
            ref={provided.innerRef}
            {...provided.droppableProps}
            widthColumn={widthColumn}
          >
            <ColumnHeaderContainer role="pipeline_column_header">
              <ColumnHeader>
                <TriangleStyleOne />
                <h2>{name}</h2>
                <ChipsItem>
                  <p>{items?.length}</p>
                </ChipsItem>
                <TriangleStyleTwo />
              </ColumnHeader>
            </ColumnHeaderContainer>
            <ColumnBody role="pipeline_column_body">
              {Array.isArray(items) &&
                items.map((item, index) => <PlannerItem key={index} item={item} index={index} />)}
              {provided.placeholder}
            </ColumnBody>
          </ColumnContainer>
        )
      }}
    </Droppable>
  )
}

PlannerColumn.propTypes = {
  index: PropTypes.number,
  name: PropTypes.string,
  items: PropTypes.array,
  widthColumn: PropTypes.string,
}

PlannerColumn.defaultProps = {
  index: -1,
  name: "Titre",
  items: [],
  widthColumn: "250px",
}

export default PlannerColumn
